/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import { Box } from "@shared-components/Box/Box";
import { Heading } from "@shared-components/Heading/Heading";
import { Text } from "@shared-components/Text/Text";
import {
  contactContainerStyles,
  contentStyles,
  linkStyles,
  headingStyles,
  imageStyles,
  imageWrapStyles,
  titleOrDepartmentStyles,
} from "./styles";
import { ContactModule } from "../../carlsberg-headless/types/modules/Contact";
import { Container } from "@shared-components/Container/Container";
import { UmbracoImage } from "@shared-components/Image/UmbracoImage/UmbracoImage";
import { FlexRow } from "@shared-components/FlexGrid/FlexGrid";
import { useDictionaryContext } from "../../context/dictionary/useDictionaryContext";
import { useSiteContext } from "../../context/site/useSiteContext";
import { DICTIONARY_MAP } from "../../carlsberg-headless/dictionary-map";

export interface ContactInformationListProps extends ContactModule {
  phoneLabel?: string;
}

const PureContactInformation: React.FC<ContactInformationListProps> = ({
  contacts,
  cbKey,
  phoneLabel,
}) => {
  if (!contacts) return null;

  return (
    <Container key={cbKey}>
      <FlexRow
        spacing={[2, 4, 6]}
        sx={{
          justifyContent: "center",
        }}
      >
        {contacts.map(
          (
            { contactName, email, image, phoneNumber, titleOrDepartment },
            idx
          ) => (
            <Box
              key={`contact${idx}-${contactName}`}
              sx={{ width: "fit-content" }}
            >
              <Box sx={contactContainerStyles}>
                {image?.fullUrl && (
                  <Box sx={imageWrapStyles}>
                    <UmbracoImage
                      sx={imageStyles}
                      width={[193]}
                      height={[193]}
                      image={image}
                      isCover
                      alt={image.altText ? image.altText : ""}
                    />
                  </Box>
                )}
                <Box sx={contentStyles}>
                  {contactName && (
                    <Heading sx={headingStyles} as="h2" variant="h6">
                      {contactName}
                    </Heading>
                  )}
                  {titleOrDepartment && (
                    <Text sx={titleOrDepartmentStyles}>
                      {titleOrDepartment}
                    </Text>
                  )}
                  {email && (
                    <Text sx={linkStyles}>
                      <a href={`mailto:${email}`}>{email}</a>
                    </Text>
                  )}
                  {phoneNumber && (
                    <Text sx={linkStyles}>
                      {`${phoneLabel ? phoneLabel + " " : ""}`}
                      <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                    </Text>
                  )}
                </Box>
              </Box>
            </Box>
          )
        )}
      </FlexRow>
    </Container>
  );
};

const ContactInformation: React.FC<ContactModule> = (props) => {
  const { get } = useDictionaryContext();
  const { currentCulture } = useSiteContext();
  return (
    <PureContactInformation
      phoneLabel={get(
        DICTIONARY_MAP.contactinformation_module.phone_label,
        currentCulture
      )}
      {...props}
    />
  );
};

export { ContactInformation, PureContactInformation };

